.mobileWrapper {
  width: 100%;
  border-bottom: 1px solid;
  background-color: var(--badge-primary-background-color);
  margin-bottom: 1.5rem;
}

@screen min-tablet {
  .mobileWrapper {
    display: none;
  }
}

.mobileLink {
  display: flex;
  align-items: center;
  padding: 1.25rem;
  color: var(--badge-primary-color);
}

.mobileLink:hover {
  background-color: var(--badge-primary-hover-background-color);
}

.desktopButton {
  background-color: var(--badge-primary-background-color);
  color: var(--badge-primary-color);
}

.desktopButton:hover {
  background-color: var(--badge-primary-hover-background-color);
}
